'use client';

import React from 'react';

import { DEV_LÄGE_AKTIVT } from 'src/lib/dev-lage';

// Only import Firebase if NOT using local auth
const USE_LOCAL_AUTH = process.env.NEXT_PUBLIC_USE_LOCAL_AUTH === 'true';

// Dynamic imports to avoid loading Firebase when using local auth
const LocalAuthProvider = React.lazy(() => import('./local/local-auth-provider').then(m => ({ default: m.LocalAuthProvider })));
const AuthProvider = !USE_LOCAL_AUTH ? React.lazy(() => import('./firebase').then(m => ({ default: m.AuthProvider }))) : null;
const DevAuthProvider = React.lazy(() => import('./dev').then(m => ({ default: m.DevAuthProvider })));

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

/**
 * Väljer inloggningsprovider.
 *
 * Prioritet:
 * 1. `NEXT_PUBLIC_USE_LOCAL_AUTH=true` → LocalAuthProvider (backend endpoints - NO Firebase)
 * 2. `DEV_LÄGE_AKTIVT` → DevAuthProvider (personas)
 * 3. Default → FirebaseProvider (production)
 */
export function AuthProviderVäljare({ children }: Props) {
  // Use local auth endpoints if configured - completely bypass Firebase
  if (USE_LOCAL_AUTH) {
    console.log('🔧 Using LocalAuthProvider - Firebase SDK disabled');
    return (
      <React.Suspense fallback={<div>Loading...</div>}>
        <LocalAuthProvider>{children}</LocalAuthProvider>
      </React.Suspense>
    );
  }

  if (DEV_LÄGE_AKTIVT) {
    return (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DevAuthProvider>{children}</DevAuthProvider>
      </React.Suspense>
    );
  }

  if (AuthProvider) {
    return (
      <React.Suspense fallback={<div>Loading...</div>}>
        <AuthProvider>{children}</AuthProvider>
      </React.Suspense>
    );
  }

  return <div>No auth provider configured</div>;
}
